import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import GeneralDialogFooter from '../shared/GeneralDialogFooter';
import SchoolCombo from "../combos/SchoolCombo";
import { Col, Form, Row } from 'react-bootstrap';



export default function AdminSpecialOperations(props) {
  const toast = useRef(null);
  const [redirectUrl, setRedirectUrl] = useState("");
  const [errorVisible, setErorVisible] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [saving, setSaving] = useState(false);


  useEffect(() => {
  }, []);
  const checkDataEntry = function(){
    return true;
  }

  const deleteRepeatedData = function(){
    if(!checkDataEntry()) return;
    setSaving(true);
    var params = {login:util.getTrustedUser()};
    var url = config.Server+`/basic/all-data/delete/repeated`;
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setErrorMessage("با موفقیت ثبت شد");
                setErorVisible(true);
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

  }
  const repareCourseCode = function(courseCode){
    if(!checkDataEntry()) return;
    setSaving(true);
    var params = {login:util.getTrustedUser()};
    var url = config.Server+`/basic/all-data/course/with-code-`+courseCode+`/set-code`;
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setErrorMessage("با موفقیت ثبت شد");
                setErorVisible(true);
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

  }
  const replaceWithSida = function(target){
    if(!checkDataEntry()) return;
    setSaving(true);
    var params = {login:util.getTrustedUser()};
    var url = config.Server+`/basic/all-data/replace/`+target+`/field`;
    axios
        .post(url, params )
        .then(res => {
            var response = res.data;
            if(response.state === "ok"){
                response = response.data;
                setErrorMessage("با موفقیت ثبت شد");
                setErorVisible(true);
                
                setSaving(false);
            }
            else{
                setErrorMessage(response.message);
                setErorVisible(true);
                setSaving(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setSaving(false);
        });

  }

  return(      
    <>
    <Row style={{marginTop:"20px"}} className='justify-content-center'>
      <Col md={4}>
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>عملیات های ویژه ادمین</div>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="داده های تکراری حذف شود" icon="pi pi-stop-circle" onClick={()=>deleteRepeatedData()} severity="danger" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="بازسازی کد درس 1000" icon="pi pi-stop-circle" onClick={()=>repareCourseCode(1000)} severity="primary" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="بازسازی کد درس 14000" icon="pi pi-stop-circle" onClick={()=>repareCourseCode(14000)} severity="primary" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="جایگزینی رشته ابتدائی با سیدا" icon="pi pi-stop-circle" onClick={()=>replaceWithSida('ebtedaei')} severity="success" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="جایگزینی رشته راهنمائی با سیدا" icon="pi pi-stop-circle" onClick={()=>replaceWithSida('rahnamaei')} severity="success" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="جایگزینی رشته انسانی با سیدا" icon="pi pi-stop-circle" onClick={()=>replaceWithSida('ensani')} severity="success" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="جایگزینی رشته تجربی با سیدا" icon="pi pi-stop-circle" onClick={()=>replaceWithSida('tajrobi')} severity="success" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>

        <Row style={{padding:"5px", marginTop:"15px"}}>
          <Col sd={6}>
            <div className="card flex justify-content-center" style={{ direction: "ltr", textAlign:"right" }}>
              <Button label="جایگزینی رشته ریاضی با سیدا" icon="pi pi-stop-circle" onClick={()=>replaceWithSida('riazi')} severity="success" iconPos="right" loading={saving} />                  
            </div>
          </Col>
        </Row>
      
      
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>
        <Row style={{padding:"5px", marginTop:"15px"}}><Col>&nbsp;</Col></Row>      
      </Col>
    </Row>   
        
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        <Toast ref={toast} />            
    </>  
  );

}
